import { createElementBlock as t, openBlock as e, createElementVNode as r } from "vue";
import n from "./index289.js";
const c = {}, l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function s(a, o, p, m, f, i) {
  return e(), t("svg", l, o[0] || (o[0] = [
    r("path", {
      fill: "currentColor",
      d: "M16.437 2.25c1.549 0 2.813 1.225 2.813 2.75v16a.75.75 0 0 1-1.162.626l-6.082-4.002-6.094 4.003a.75.75 0 0 1-1.155-.524L4.75 21V5c0-1.525 1.264-2.75 2.813-2.75h8.874Zm0 1.5H7.563c-.73 0-1.313.565-1.313 1.25v14.611l5.347-3.51a.75.75 0 0 1 .727-.054l.097.054 5.329 3.507V5c0-.643-.512-1.179-1.178-1.243l-.135-.007Z"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ n(c, [["render", s]]);
export {
  u as default
};
